
// Randomly sorts an array
export const randomSort = (a, b) => {
  const temp = parseInt(Math.random() * 10, 10)
  const isOddOrEven = temp % 2
  const isPosOrNeg = temp > 5 ? 1 : -1
  return (isOddOrEven * isPosOrNeg)
}


// WEBPACK FOOTER //
// ./src/utils.js